import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07711f96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invoiceform" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "申请开票", -1))
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont" }, "", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "发票将通过快递的方式邮寄,请注意查收。", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "发票信息相关问题>>", -1))
const _hoisted_8 = {
  key: 1,
  class: "type"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "发票类型(纸质)", -1))
const _hoisted_10 = { class: "mb-2 flex items-center text-sm" }
const _hoisted_11 = {
  key: 2,
  class: "ordinary"
}
const _hoisted_12 = { class: "one" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p" }, "抬头类型", -1))
const _hoisted_14 = { class: "mb-2 flex items-center text-sm" }
const _hoisted_15 = {
  key: 0,
  class: "self1"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blue" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("span", null, "开票信息")
], -1))
const _hoisted_17 = { class: "invoicecontents" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "发票内容", -1))
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  style: {"margin":"0px"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "商品明细", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "(发票内容将显示详细商品名称与价格信息，如有特殊需求请联系客服)", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blue" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("span", null, "收票信息")
], -1))
const _hoisted_25 = { class: "address" }
const _hoisted_26 = {
  key: 0,
  class: "noaddress"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "暂无收货地址"),
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont" }, "")
], -1))
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "name" }
const _hoisted_30 = { class: "useraddress" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 1,
  class: "form-box"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titles" }, "填写地址", -1))
const _hoisted_34 = { class: "infos" }
const _hoisted_35 = {
  key: 2,
  class: "footed"
}
const _hoisted_36 = {
  key: 3,
  class: "footed"
}
const _hoisted_37 = {
  key: 1,
  class: "self1"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blue" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("span", null, "开票信息")
], -1))
const _hoisted_39 = { class: "invoicecontents" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "发票内容", -1))
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  key: 1,
  style: {"margin":"0px"}
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "商品明细", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "(发票内容将显示详细商品名称与价格信息，如有特殊需求请联系客服)", -1))
const _hoisted_45 = [
  _hoisted_43,
  _hoisted_44
]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blue" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("span", null, "收票信息")
], -1))
const _hoisted_47 = { class: "address" }
const _hoisted_48 = {
  key: 0,
  class: "noaddress"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "暂无收货地址"),
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont" }, "")
], -1))
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "name" }
const _hoisted_52 = { class: "useraddress" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  key: 1,
  class: "form-box"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titles" }, "填写地址", -1))
const _hoisted_56 = { class: "infos" }
const _hoisted_57 = {
  key: 2,
  class: "footed"
}
const _hoisted_58 = {
  key: 3,
  class: "footed"
}
const _hoisted_59 = {
  key: 3,
  class: "special"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blue" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("p", null, "开票信息")
], -1))
const _hoisted_61 = { class: "invoicecontent" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "发票内容", -1))
const _hoisted_63 = { key: 0 }
const _hoisted_64 = {
  key: 1,
  style: {"margin":"0px"}
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "商品明细", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "(发票内容将显示详细商品名称与价格信息，如有特殊需求请联系客服)", -1))
const _hoisted_67 = [
  _hoisted_65,
  _hoisted_66
]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blue" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("p", null, "收票信息")
], -1))
const _hoisted_69 = { class: "address" }
const _hoisted_70 = {
  key: 0,
  class: "noaddress"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "暂无收货地址"),
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont" }, "")
], -1))
const _hoisted_72 = ["onClick"]
const _hoisted_73 = { class: "name" }
const _hoisted_74 = { class: "useraddress" }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = {
  key: 1,
  class: "form-box"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titles" }, "填写地址", -1))
const _hoisted_78 = { class: "infos" }
const _hoisted_79 = {
  key: 2,
  class: "footed"
}
const _hoisted_80 = {
  key: 3,
  class: "footed"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_invoice_submit_vue = _resolveComponent("invoice-submit-vue")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_elui_china_area_dht = _resolveComponent("elui-china-area-dht")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("i", {
        class: "icon iconfont icon-shanchu",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _hoisted_6,
      _createVNode(_component_router_link, { to: {
          name: 'customer',
          params: {
            comName: 'Fapiao',
          },
        } }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      })
    ]),
    (!_ctx.goShow)
      ? (_openBlock(), _createBlock(_component_invoice_submit_vue, {
          key: 0,
          selfForm: _ctx.selfForm,
          firmForm: _ctx.firmForm,
          radio1: _ctx.radio1,
          radio2: _ctx.radio2,
          lastInfor: _ctx.lastInfor,
          exclusiveForm: _ctx.exclusiveForm,
          isEdit: _ctx.isEdit,
          onMclose: _ctx.mclose,
          onChangeGoShow: _ctx.changeGoShow
        }, null, 8, ["selfForm", "firmForm", "radio1", "radio2", "lastInfor", "exclusiveForm", "isEdit", "onMclose", "onChangeGoShow"]))
      : _createCommentVNode("", true),
    (_ctx.goShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_radio_group, {
              modelValue: _ctx.radio1,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.radio1) = $event)),
              class: "ml-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "1",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("普通发票")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "2",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("增值税专用发票")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.radio1 == '1' && _ctx.goShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.radio2,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.radio2) = $event)),
                class: "ml-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    label: "1",
                    size: "large",
                    class: "self"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("个人")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    label: "2",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("单位")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          (_ctx.radio2 == '1' && _ctx.goShow)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_el_form, {
                  ref: "ruleFormRef2",
                  model: _ctx.commonselfForm,
                  rules: _ctx.rules2,
                  "label-width": "120px",
                  class: "demo-ruleForm",
                  "status-icon": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "个人名称",
                      prop: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.commonselfForm.name,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.commonselfForm.name) = $event)),
                          placeholder: "请填写您的姓名"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      (_ctx.from != 2)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_19, "信息服务费"))
                        : _createCommentVNode("", true),
                      (_ctx.from == 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_23))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_24,
                    (_ctx.show)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          label: "收票地址",
                          prop: "address"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_25, [
                              (_ctx.addressList.data.length <= 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _hoisted_27,
                                    _createElementVNode("p", {
                                      class: "add",
                                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addlocation && _ctx.addlocation(...args)))
                                    }, "添加地址")
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.addressList.data.length > 0)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass([{ haveaddress1: _ctx.down }, "haveaddress"])
                                  }, [
                                    (_ctx.down == false)
                                      ? (_openBlock(), _createElementBlock("i", {
                                          key: 0,
                                          class: "iconfont",
                                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.down = !_ctx.down))
                                        }, ""))
                                      : _createCommentVNode("", true),
                                    (_ctx.down)
                                      ? (_openBlock(), _createElementBlock("i", {
                                          key: 1,
                                          class: "iconfont",
                                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.down = !_ctx.down))
                                        }, ""))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addressList.data, (item, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: _normalizeClass(["userone", { oneback: index == 0 }]),
                                        key: index,
                                        onClick: ($event: any) => (_ctx.chessaddress(index))
                                      }, [
                                        _createElementVNode("div", _hoisted_29, [
                                          _createElementVNode("div", null, _toDisplayString(item.contacts), 1),
                                          _createElementVNode("p", null, _toDisplayString(item.phonenumber), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_30, [
                                          _createTextVNode(_toDisplayString(item.address) + " ", 1),
                                          (_ctx.down)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: "changeadd",
                                                onClick: _withModifiers(($event: any) => (_ctx.updateAddress(item)), ["stop"])
                                              }, " 修改地址 ", 8, _hoisted_31))
                                            : _createCommentVNode("", true)
                                        ])
                                      ], 10, _hoisted_28))
                                    }), 128)),
                                    (_ctx.addressList.data.length < 3)
                                      ? (_openBlock(), _createElementBlock("p", {
                                          key: 2,
                                          class: "add",
                                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.addlocation && _ctx.addlocation(...args)))
                                        }, " 添加地址 "))
                                      : _createCommentVNode("", true)
                                  ], 2))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.show == false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _hoisted_33,
                          _createVNode(_component_el_form, {
                            model: _ctx.address.data,
                            rules: _ctx.rules,
                            ref: "ruleFormRefs",
                            "label-width": "80px",
                            "label-position": "left"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: "收货人",
                                prop: "contacts"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.address.data.contacts,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.address.data.contacts) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, {
                                label: "手机号码",
                                prop: "phonenumber"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.address.data.phonenumber,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.address.data.phonenumber) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, {
                                label: "所在地区",
                                prop: "area",
                                class: "addressinput"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_elui_china_area_dht, {
                                    onChange: _ctx.onChange,
                                    placeholder: "请选择地区",
                                    modelValue: _ctx.userForm.addr,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.userForm.addr) = $event))
                                  }, null, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, {
                                label: "详细地址",
                                prop: "address"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.address.data.address,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.address.data.address) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_34, [
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      round: "",
                                      class: "button1",
                                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.show = !_ctx.show))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("取消")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onSubmit(_ctx.ruleFormRefs))),
                                      round: "",
                                      class: "button2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("保存")
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["model", "rules"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.from != 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, " 2个工作日内以快递(顺丰快递)的方式邮寄出,配送到您所预留的收票地址,请注意查收! "))
                      : _createCommentVNode("", true),
                    (_ctx.from == 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, " 发票随货物一同寄出，请注意查收! "))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef2, 1))),
                          class: "routine"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("申请开票")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.radio2 == '2' && _ctx.goShow)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _hoisted_38,
                _createVNode(_component_el_form, {
                  ref: "ruleFormRef1",
                  model: _ctx.commonForm,
                  rules: _ctx.rules1,
                  "label-width": "120px",
                  class: "demo-ruleForm",
                  "status-icon": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "单位名称",
                      prop: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_autocomplete, {
                          modelValue: _ctx.commonForm.name,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.commonForm.name) = $event)),
                          "fetch-suggestions": _ctx.querySearch,
                          clearable: "",
                          onSelect: _ctx.handleSelect
                        }, null, 8, ["modelValue", "fetch-suggestions", "onSelect"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "单位税号",
                      prop: "number"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.commonForm.number,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.commonForm.number) = $event)),
                          placeholder: "请填写纳税人识别号或统一社会信用代码"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_39, [
                      _hoisted_40,
                      (_ctx.from != 2)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_41, "信息服务费"))
                        : _createCommentVNode("", true),
                      (_ctx.from == 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_45))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_46,
                    (_ctx.show)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          label: "收票地址",
                          prop: "address"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_47, [
                              (_ctx.addressList.data.length <= 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                    _hoisted_49,
                                    _createElementVNode("p", {
                                      class: "add",
                                      onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.addlocation && _ctx.addlocation(...args)))
                                    }, "添加地址")
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.addressList.data.length > 0)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass([{ haveaddress1: _ctx.down }, "haveaddress"])
                                  }, [
                                    (_ctx.down == false)
                                      ? (_openBlock(), _createElementBlock("i", {
                                          key: 0,
                                          class: "iconfont",
                                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.down = !_ctx.down))
                                        }, ""))
                                      : _createCommentVNode("", true),
                                    (_ctx.down)
                                      ? (_openBlock(), _createElementBlock("i", {
                                          key: 1,
                                          class: "iconfont",
                                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.down = !_ctx.down))
                                        }, ""))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addressList.data, (item, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: _normalizeClass(["userone", { oneback: index == 0 }]),
                                        key: index,
                                        onClick: ($event: any) => (_ctx.chessaddress(index))
                                      }, [
                                        _createElementVNode("div", _hoisted_51, [
                                          _createElementVNode("div", null, _toDisplayString(item.contacts), 1),
                                          _createElementVNode("p", null, _toDisplayString(item.phonenumber), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_52, [
                                          _createTextVNode(_toDisplayString(item.address) + " ", 1),
                                          (_ctx.down)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: "changeadd",
                                                onClick: _withModifiers(($event: any) => (_ctx.updateAddress(item)), ["stop"])
                                              }, " 修改地址 ", 8, _hoisted_53))
                                            : _createCommentVNode("", true)
                                        ])
                                      ], 10, _hoisted_50))
                                    }), 128)),
                                    (_ctx.addressList.data.length < 3)
                                      ? (_openBlock(), _createElementBlock("p", {
                                          key: 2,
                                          class: "add",
                                          onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.addlocation && _ctx.addlocation(...args)))
                                        }, " 添加地址 "))
                                      : _createCommentVNode("", true)
                                  ], 2))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.show == false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _hoisted_55,
                          _createVNode(_component_el_form, {
                            model: _ctx.address.data,
                            rules: _ctx.rules,
                            ref: "ruleFormRefs",
                            "label-width": "80px",
                            "label-position": "left"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: "收货人",
                                prop: "contacts"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.address.data.contacts,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.address.data.contacts) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, {
                                label: "手机号码",
                                prop: "phonenumber"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.address.data.phonenumber,
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.address.data.phonenumber) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, {
                                label: "所在地区",
                                prop: "area",
                                class: "addressinput"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_elui_china_area_dht, {
                                    onChange: _ctx.onChange,
                                    placeholder: "请选择地区",
                                    modelValue: _ctx.userForm.addr,
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.userForm.addr) = $event))
                                  }, null, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, {
                                label: "详细地址",
                                prop: "address"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.address.data.address,
                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.address.data.address) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_56, [
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      round: "",
                                      class: "button1",
                                      onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.show = !_ctx.show))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("取消")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.onSubmit(_ctx.ruleFormRefs))),
                                      round: "",
                                      class: "button2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("保存")
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["model", "rules"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.from != 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, " 22个工作日内以快递(顺丰快递)的方式邮寄出,配送到您所预留的收票地址,请注意查收! "))
                      : _createCommentVNode("", true),
                    (_ctx.from == 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, " 发票随货物一同寄出，请注意查收! "))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.submitFormone(_ctx.ruleFormRef1))),
                          class: "routine"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("申请开票")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.radio1 == '2' && _ctx.goShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
          _hoisted_60,
          _createVNode(_component_el_form, {
            ref: "ruleFormRef",
            model: _ctx.specialForm,
            rules: _ctx.rule,
            "label-width": "120px",
            class: "demo-ruleForm",
            "status-icon": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "单位名称",
                prop: "name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_autocomplete, {
                    modelValue: _ctx.specialForm.name,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.specialForm.name) = $event)),
                    "fetch-suggestions": _ctx.querySearch,
                    clearable: "",
                    onSelect: _ctx.handleSelect
                  }, null, 8, ["modelValue", "fetch-suggestions", "onSelect"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "单位税号",
                prop: "number"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.specialForm.number,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.specialForm.number) = $event)),
                    placeholder: "请填写纳税人识别号或统一社会信用代码"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "单位地址",
                prop: "company_address"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.specialForm.company_address,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.specialForm.company_address) = $event)),
                    placeholder: "请填写单位地址"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "单位电话",
                prop: "mobile"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.specialForm.mobile,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.specialForm.mobile) = $event)),
                    placeholder: "请填写单位电话"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "开户银行",
                prop: "bank"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.specialForm.bank,
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.specialForm.bank) = $event)),
                    placeholder: "请填写开户银行"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "银行账号",
                prop: "card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.specialForm.card,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.specialForm.card) = $event)),
                    placeholder: "请填写银行账号"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_61, [
                _hoisted_62,
                (_ctx.from != 2)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_63, "信息服务费"))
                  : _createCommentVNode("", true),
                (_ctx.from == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, _hoisted_67))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_68,
              (_ctx.show)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: "收票地址",
                    prop: "address"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_69, [
                        (_ctx.addressList.data.length <= 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                              _hoisted_71,
                              _createElementVNode("p", {
                                class: "add",
                                onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.addlocation && _ctx.addlocation(...args)))
                              }, "添加地址")
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.addressList.data.length > 0)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass([{ haveaddress1: _ctx.down }, "haveaddress"])
                            }, [
                              (_ctx.down == false)
                                ? (_openBlock(), _createElementBlock("i", {
                                    key: 0,
                                    class: "iconfont",
                                    onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.down = !_ctx.down))
                                  }, ""))
                                : _createCommentVNode("", true),
                              (_ctx.down)
                                ? (_openBlock(), _createElementBlock("i", {
                                    key: 1,
                                    class: "iconfont",
                                    onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.down = !_ctx.down))
                                  }, ""))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addressList.data, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: _normalizeClass(["userone", { oneback: index == 0 }]),
                                  key: index,
                                  onClick: ($event: any) => (_ctx.chessaddress(index))
                                }, [
                                  _createElementVNode("div", _hoisted_73, [
                                    _createElementVNode("div", null, _toDisplayString(item.contacts), 1),
                                    _createElementVNode("p", null, _toDisplayString(item.phonenumber), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_74, [
                                    _createTextVNode(_toDisplayString(item.address) + " ", 1),
                                    (_ctx.down)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "changeadd",
                                          onClick: _withModifiers(($event: any) => (_ctx.updateAddress(item)), ["stop"])
                                        }, " 修改地址 ", 8, _hoisted_75))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 10, _hoisted_72))
                              }), 128)),
                              (_ctx.addressList.data.length < 3)
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 2,
                                    class: "add",
                                    onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.addlocation && _ctx.addlocation(...args)))
                                  }, " 添加地址 "))
                                : _createCommentVNode("", true)
                            ], 2))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.show == false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                    _hoisted_77,
                    _createVNode(_component_el_form, {
                      model: _ctx.address.data,
                      rules: _ctx.rules,
                      ref: "ruleFormRefs",
                      "label-width": "80px",
                      "label-position": "left"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "收货人",
                          prop: "contacts"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.address.data.contacts,
                              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.address.data.contacts) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "手机号码",
                          prop: "phonenumber"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.address.data.phonenumber,
                              "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.address.data.phonenumber) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "所在地区",
                          prop: "area",
                          class: "addressinput"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_elui_china_area_dht, {
                              onChange: _ctx.onChange,
                              placeholder: "请选择地区",
                              modelValue: _ctx.userForm.addr,
                              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.userForm.addr) = $event))
                            }, null, 8, ["onChange", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "详细地址",
                          prop: "address"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.address.data.address,
                              "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.address.data.address) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_78, [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                round: "",
                                class: "button1",
                                onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.show = !_ctx.show))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("取消")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.onSubmit(_ctx.ruleFormRefs))),
                                round: "",
                                class: "button2"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("保存")
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model", "rules"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.from != 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_79, " 22个工作日内以快递(顺丰快递)的方式邮寄出,配送到您所预留的收票地址,请注意查收! "))
                : _createCommentVNode("", true),
              (_ctx.from == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_80, " 发票随货物一同寄出，请注意查收! "))
                : _createCommentVNode("", true),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.submitFormtwo(_ctx.ruleFormRef))),
                    class: "routine"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("申请开票")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]))
      : _createCommentVNode("", true)
  ]))
}